module.exports = __webpack_public_path__ + "static/media/Mediation_active_blue.4bd1ca7c.svg";